import React, { useEffect, useState } from 'react'
import { Grid, List, ListItem, ListItemButton, ListItemIcon, ListItemText, ScopedCssBaseline, ThemeProvider, Typography } from '@mui/material'
import { darkTheme } from '../assets/styles/theme'
import services from '../constants/services.json'
import ContactForm from './ContactForm'
import DoneIcon from '@mui/icons-material/Done';

function Cover() {
  const [imgLast, setImgLast] = useState(0);
  const [imgCurrent, setImgCurrent] = useState(0);
  const [servSelected, setServSelected] = useState<number|undefined>();
  const [classCurrent, setClassCurrent] = useState<''|'show'|'hide'>('hide');

  const getImgIdx = () => imgCurrent === services.length-1 ? 0 : imgCurrent + 1
  const getImg = (index:number) => `url(images/sections/${services[index].image})`

  const updateImgs = (index:number) => {
    setImgCurrent( index )
    setClassCurrent( 'show' )
    setTimeout(()=>{
      setImgLast( index )
      setClassCurrent( 'hide' )
    }, 250);
  }

  useEffect(() => {
    if (servSelected === undefined) {
      setTimeout(() => {
        updateImgs(getImgIdx())
      }, 5000)
    }
  }, [imgCurrent, servSelected]);

  // const onImgSelected = (index:number)=>{
  //   setServSelected(index)
  //   updateImgs(index)
  // }

  return (
  <ThemeProvider theme={darkTheme}>
    <ScopedCssBaseline
    sx={{position:'relative', zIndex:30, backgroundColor:'var(--dark)'}}>

      <div className='cover'>
        <div className="coverImg"
          style={{backgroundImage: getImg(imgLast)}}
        ></div>
        <div className={`coverImg ${classCurrent}`}
          style={{backgroundImage: getImg(imgCurrent)}}
        ></div>
      </div>

      <Grid container
        className='services'
        spacing='8'
        justifyContent="space-between"
        sx={{mt:6, p:8, position:'relative', zIndex:'10'}}
      >
        <Grid item xs={12} md={6} lg={4}>
          <Typography variant='h3'>
          Especialistas en
          </Typography>
          <List>
            {services.map( (s,i) =>
              <ListItem disablePadding
                key={s.title}
                sx={{cursor:"default"}}
                // onMouseOver={()=>onImgSelected(i)}
                // onMouseLeave={()=>setServSelected(undefined)}
              >
                <ListItemButton href={`#${s.id}`}>
                  <ListItemIcon> <DoneIcon /> </ListItemIcon>
                  <ListItemText primary={s.title}/>
                </ListItemButton>
              </ListItem>,
            )}
          </List>
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <ContactForm title='Quiero saber más'/>
        </Grid>
      </Grid>
    </ScopedCssBaseline>
  </ThemeProvider>
  )
}

export default Cover